<form [formGroup]="form" class="report-filters">
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-calendar formControlName="startDate" [placeholder]="'From Date'" [iconDisplay]="'input'"
                [showIcon]="true"></p-calendar>
        </span>
    </div>
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-calendar formControlName="endDate" [placeholder]="'To Date'" [iconDisplay]="'input'"
                [showIcon]="true"></p-calendar>
        </span>
    </div>
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-dropdown formControlName="channel" [showClear]="true" [options]="salesChannels"
                placeholder="Channel"></p-dropdown>
        </span>
    </div>

    <div class="controls-wrapper button-wrapper">
        <p-button label="Search" [text]="true" (onClick)="submit()" [raised]="true"
            [disabled]="form.invalid" severity="success" class="report-action-button"
            icon="pi pi-search"></p-button>
        <p-button label="Export" [text]="true" (onClick)="export()" [raised]="true"
            severity="success" class="report-action-button" icon="pi pi-download"></p-button>
    </div>
</form>
<hr />
<div class="table-container">
    <p-table [value]="reports" [scrollable]="true" #reportTable scrollHeight="400px"
        styleClass="p-datatable-striped" [tableStyle]="{ 'min-width': '50rem' }" id="smeReportsTable"
        responsiveLayout="stack" [breakpoint]="'768px'">
        <ng-template pTemplate="header">
            <tr>
                <th>Date Created</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Id Number</th>
                <th>D.O.B</th>
                <th>Gender</th>
                <th>Email</th>
                <th>Mobile Number</th>
                <th>Next Of Kin</th>
                <th>Next Of Kin Mobile</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-report>
            <tr>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Date Created</span>
                    {{ report.dateCreated | date : "dd/MM/yyyy" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">First Name</span>
                    {{ report.firstName ? report.firstName : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Last Name</span>
                    {{ report.lastName ? report.lastName : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Id Number</span>
                    {{ report.idNumber ? report.idNumber : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">D.O.B</span>
                    {{ report.dob ? report.dob : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Gender</span>
                    {{ report.gender ? report.gender : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Email</span>
                    {{ report.email ? report.email : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Mobile Number</span>
                    {{ report.mobileNumber.countryCode.toString() + report.mobileNumber.phoneNumber.toString() }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Next Of Kin</span>
                    {{ report.nextOfKin ? report.nextOfKin.fullName : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Next Of Kin Mobile</span>
                    {{ report.nextOfKin ? report.nextOfKin.contactNumber.toString() : "---" }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
